/**
 * Барьер изоляции в стеке хоткеев.
 * Блокирует все хоткеи, зарегистрированные НИЖЕ барьера (раньше по времени).
 */
export interface IsolateBarrier {
    /** Уникальный идентификатор барьера */
    barrierId: string;
}

/**
 * Обработчик хоткея для регистрации в системе.
 * Содержит всю необходимую информацию для обработки нажатия клавиш.
 */
export interface HotKeyHandler {
    /** Уникальный идентификатор обработчика */
    id: string;
    /** Идентификатор компонента, которому принадлежит обработчик */
    componentId: string;
    /* Название хэндлера для отображения в дебаге*/
    handlerName?: string;
    /** Клавиши или комбинации клавиш для обработки */
    keys: string;
    /** Функция вызываемая при нажатии клавиш */
    callback: (event: KeyboardEvent) => void;
    /** Нужно ли вызывать callback на keyup event */
    keyUp?: boolean;
    /** Нужно ли вызывать callback несколько раз при долгом нажатии клавиши */
    repeat?: boolean;

    preventDefault?: boolean;
    stopPropagation?: boolean;
    stopImmediatePropagation?: boolean;
    /** Функция проверки доступности хэндлера, вызываемая при поиске активного хэндлера */
    staticAvailabilityCheck?: () => boolean;
}

/**
 * Регистрация хоткея в системе.
 * Предоставляет методы для управления зарегистрированным хоткеем.
 */
export interface HotKeyRegistration {
    /** Отменяет регистрацию хоткея и удаляет его из системы */
    unregister: () => void;
    /** Обновляет колбэк, если какая-то из его зависимостей обновилась  */
    updateCallback: (callback: (event: KeyboardEvent) => void) => void;
}

/**
 * Элемент стека: либо обработчик хоткея, либо барьер изоляции
 */
export type StackItem = HotKeyHandler | IsolateBarrier;

/**
 * Type guard: проверяет, является ли элемент барьером
 */
export function isBarrier(item: StackItem): item is IsolateBarrier {
    return 'barrierId' in item;
}

/**
 * Type guard: проверяет, является ли элемент обработчиком
 */
export function isHandler(item: StackItem): item is HotKeyHandler {
    return 'keys' in item;
}
